import type {
  ClaimRegisterDocument,
  ClaimRegisterRequest,
} from "@tm/insurance/api";

import type { ClaimFormField } from "../../types";

export interface BuildRegisterRequestArgs {
  fields: ClaimFormField[];
  values: Record<string, string>;
  docsByField: Record<string, ClaimRegisterDocument[]>;
  partnerBookingId?: string;
  bookingId?: string;
  currency: string;
  benefitKey: string;
  keyOf: (field: ClaimFormField, index: number) => string;
}

export function buildRegisterRequest({
  fields,
  values,
  docsByField,
  partnerBookingId,
  bookingId,
  currency,
  benefitKey,
  keyOf,
}: BuildRegisterRequestArgs): ClaimRegisterRequest {
  const data: Array<{ key: string; value: string[] }> = [];
  const docs: ClaimRegisterRequest["claims"][number]["docs"] = [];

  fields.forEach((field, index) => {
    const key = keyOf(field, index);

    if (field.type === "fileUploader") {
      const claimDocuments = docsByField[key];
      if (claimDocuments?.length) {
        docs.push({
          key,
          claimDocuments,
        });
      }
      return;
    }

    const value = (values[key] ?? "").trim();
    if (!value) return;
    data.push({ key, value: [value] });
  });

  const request: ClaimRegisterRequest = {
    currency,
    benefitKey,
    claims: [{ data, docs }],
  };
  if (bookingId) {
    request.bookingId = bookingId;
  }
  if (partnerBookingId) {
    request.partnerBookingId = partnerBookingId;
  }
  return request;
}
